import React from 'react';
import { Grid } from '@mui/material';
import ActivityNoteFields from './ActivityNoteFields';
import ActivityTaskFields from './ActivityTaskFields';
import ActivityCallFields from './ActivityCallFields';
import ActivityEmailTextFields from './ActivityEmailTextFields';
import ActivityMeetingFields from './ActivityMeetingFields';
import { ActivityTypeEnum } from 'src/types/activityType';

interface Props {
  formState: any;
  handleFieldChange: (field: string, value: any) => void;
}

const ActivityFields: React.FC<Props> = ({ formState, handleFieldChange }) => {
  return (
    <>
      {/* Note */}
      {formState.formActivity.activityTypeId === ActivityTypeEnum.Note && (
        <Grid size={{ xs: 12 }}>
          <ActivityNoteFields />
        </Grid>
      )}

      {/* Task */}
      {formState.formActivity.activityTypeId == ActivityTypeEnum.Task && (
        <Grid size={{ xs: 12 }}>
          <ActivityTaskFields
            formState={formState}
            onAssignedToChange={(val) => handleFieldChange('assignedTo', val)}
            onDueDateChange={(val) => handleFieldChange('dueDate', val)}
            onAddToOutlookChange={(val) => handleFieldChange('addToOutlook', val)}
          />
        </Grid>
      )}

      {/* Call */}
      {formState.formActivity.activityTypeId == ActivityTypeEnum.Call && (
        <Grid size={{ xs: 12 }}>
          <ActivityCallFields
            formState={formState}
            onRespondChange={(val) => handleFieldChange('didRespond', val)}
            onCallDirectionChange={(val) => handleFieldChange('callDirection', val)}
            onFollowUpDateChange={(val) => handleFieldChange('followUpDate', val)}
          />
        </Grid>
      )}

      {/* Communication */}
      {formState.formActivity.activityTypeId == ActivityTypeEnum.Communication && (
        <Grid size={{ xs: 12 }}>
          <ActivityEmailTextFields
            formState={formState}
            onDidRespond={(val) => handleFieldChange('didRespond', val)}
            onFollowUpDateChange={(val) => handleFieldChange('followUpDate', val)}
          />
        </Grid>
      )}

      {/* Meeting */}
      {formState.formActivity.activityTypeId == ActivityTypeEnum.Meeting && (
        <Grid size={{ xs: 12 }}>
          <ActivityMeetingFields
            formState={formState}
            onProgramsChange={(val) => handleFieldChange('programs', val)}
            onContactsChange={(val) => handleFieldChange('contacts', val)}
          />
        </Grid>
      )}
    </>
  );
};

export default ActivityFields;
